import React from "react";
import { EntityChangeContextInterface } from "module/entity/context/change/EntityChangeContext";

export type TrainingCustomAssigneeChangeContextInterface =
  EntityChangeContextInterface;

const TrainingCustomAssigneeChangeContext = React.createContext(
  <TrainingCustomAssigneeChangeContextInterface>{}
);

export default TrainingCustomAssigneeChangeContext;
